// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../../node_modules/.pnpm/postcss-loader@8.2.0_postcss@8.5.23_typescript@5.9.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../components/ui-table/ui-table.styles.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.admin-shell {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 260px 1fr;
  background: radial-gradient(140% 140% at 20% 20%, #eef2ff, #e6ecf9 55%, #dfe6f5);
  color: #0f172a;
}

.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  background: linear-gradient(180deg, #0b1021 0%, #12172b 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);
  z-index: 1000;
  color: #e5e7eb;
}

.main-panel {
  min-height: 100vh;
  background: radial-gradient(120% 120% at 20% 20%, #f8fafc, #eef2ff 55%, #e7ecf7);
  display: grid;
  grid-template-rows: auto 1fr auto;
  border-left: 1px solid rgba(12, 20, 39, 0.04);
  row-gap: 12px;
}

.main-content-shell {
  padding: 20px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.footer-shell {
  padding: 0 16px 14px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

@media (max-width: 1024px) {
  .admin-shell {
    grid-template-columns: 84px 1fr;
  }
  .main-content-shell {
    padding: 20px;
  }
}
@media (max-width: 768px) {
  .admin-shell {
    grid-template-columns: 1fr;
  }
  .sidebar {
    position: fixed;
    width: 240px;
    transform: translateX(-260px);
    transition: transform 0.25s ease;
  }
  .main-panel {
    grid-template-rows: auto 1fr auto;
  }
}
.admin-shell.sidebar-collapsed {
  grid-template-columns: 84px 1fr;
}

.admin-shell.sidebar-collapsed .sidebar {
  width: 84px;
}

.admin-shell.sidebar-collapsed .sidebar .logo-label,
.admin-shell.sidebar-collapsed .sidebar .nav p,
.admin-shell.sidebar-collapsed .sidebar-footer {
  display: none;
}

.admin-shell.sidebar-collapsed .sidebar .nav .nav-link {
  justify-content: center;
}

.admin-shell.sidebar-collapsed .main-content-shell,
.admin-shell.sidebar-collapsed .footer-shell {
  padding-left: 18px;
  padding-right: 18px;
}`, "",{"version":3,"sources":["webpack://./projects/admin/src/layouts/admin-layout/admin-layout.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;AAAF;;AAGA;EACE,iBAAA;EACA,aAAA;EACA,gCAAA;EACA,gFAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,6DAAA;EACA,iDAAA;EACA,2CAAA;EACA,aAAA;EACA,cAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gFAAA;EACA,aAAA;EACA,iCAAA;EACA,6CAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAAF;;AAGA;EACE,oBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE;IACE,+BAAA;EAAF;EAGA;IACE,aAAA;EADF;AACF;AAIA;EACE;IACE,0BAAA;EAFF;EAKA;IACE,eAAA;IACA,YAAA;IACA,6BAAA;IACA,gCAAA;EAHF;EAMA;IACE,iCAAA;EAJF;AACF;AAOA;EACE,+BAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;;;EAGE,aAAA;AALF;;AAQA;EACE,uBAAA;AALF;;AAQA;;EAEE,kBAAA;EACA,mBAAA;AALF","sourcesContent":["@import '../../components/ui-table/ui-table.styles.css';\n\n:host {\n  display: block;\n}\n\n.admin-shell {\n  min-height: 100vh;\n  display: grid;\n  grid-template-columns: 260px 1fr;\n  background: radial-gradient(140% 140% at 20% 20%, #eef2ff, #e6ecf9 55%, #dfe6f5);\n  color: #0f172a;\n}\n\n.sidebar {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  background: linear-gradient(180deg, #0b1021 0%, #12172b 100%);\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);\n  z-index: 1000;\n  color: #e5e7eb;\n}\n\n.main-panel {\n  min-height: 100vh;\n  background: radial-gradient(120% 120% at 20% 20%, #f8fafc, #eef2ff 55%, #e7ecf7);\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  border-left: 1px solid rgba(12, 20, 39, 0.04);\n  row-gap: 12px;\n}\n\n.main-content-shell {\n  padding: 20px;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.footer-shell {\n  padding: 0 16px 14px;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n@media (max-width: 1024px) {\n  .admin-shell {\n    grid-template-columns: 84px 1fr;\n  }\n\n  .main-content-shell {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-shell {\n    grid-template-columns: 1fr;\n  }\n\n  .sidebar {\n    position: fixed;\n    width: 240px;\n    transform: translateX(-260px);\n    transition: transform 0.25s ease;\n  }\n\n  .main-panel {\n    grid-template-rows: auto 1fr auto;\n  }\n}\n\n.admin-shell.sidebar-collapsed {\n  grid-template-columns: 84px 1fr;\n}\n\n.admin-shell.sidebar-collapsed .sidebar {\n  width: 84px;\n}\n\n.admin-shell.sidebar-collapsed .sidebar .logo-label,\n.admin-shell.sidebar-collapsed .sidebar .nav p,\n.admin-shell.sidebar-collapsed .sidebar-footer {\n  display: none;\n}\n\n.admin-shell.sidebar-collapsed .sidebar .nav .nav-link {\n  justify-content: center;\n}\n\n.admin-shell.sidebar-collapsed .main-content-shell,\n.admin-shell.sidebar-collapsed .footer-shell {\n  padding-left: 18px;\n  padding-right: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
